import { createSelector } from '@reduxjs/toolkit';
import { selectSelectedDevice } from 'entities/device/lib';
export const openCameraContentDialog = () => ({ type: 'OPEN_CAMERA_CONTENT_DIALOG' });
export const closeCameraContentDialog = () => ({ type: 'CLOSE_CAMERA_CONTENT_DIALOG' });
export const getPhotosByPeriodFromServer = (device_id, time) => async (dispatch, getState, { api }) => {
    dispatch({
        type: 'GET_PHOTOS_BY_PERIOD_FROM_SERVER__REQUEST',
    });
    const photos = (await api.get_photos_by_period(device_id, time)).photos;
    dispatch({
        type: 'GET_PHOTOS_BY_PERIOD_FROM_SERVER__OK',
        photos,
        device_id,
    });
};
export const select_device_photos_by_period = createSelector((state) => selectSelectedDevice(state), (state) => state.camera_photos_by_period, (device, camera_photos) => (device == null ? [] : camera_photos?.photos ?? []));
